import { faTrashCan } from "@fortawesome/pro-duotone-svg-icons";
import ColorChangingIcon from "../../../Common/UI/ColorChangingIcon";
import { CustomPeoplePicker } from "../../../Common/UI/CustomPeoplePicker";
import { datasetData } from "../../NewDatasetSignals";

export const PeoplePickerCell = (props) => {
  const handlePersonChange = (e) => {
    const inEditID = props.dataItem.id;
    const selectedPeople = e.target.selectedPeople || [];
    const selectedPerson = selectedPeople.length > 0 ? selectedPeople[0] : null;

    const newData = props.data.map((item) =>
      item.id === inEditID
        ? {
            ...item,
            person: selectedPerson,
          }
        : item
    );
    datasetData.value = { ...datasetData.value, values: newData };
  };

  return (
    <td>
      <CustomPeoplePicker
        name={"peoplePickerUserGroup_" + props.dataIndex}
        selectedPeople={props.dataItem.person ? [props.dataItem.person] : []}
        selectionMode="single"
        onChange={handlePersonChange}
        valid={!!props.dataItem.person}
        data-testid={"peoplePickerUserGroup_" + props.dataIndex}
      />
    </td>
  );
};

export const DeleteCell = (props) => {
  const handleDeleteRecord = () => {
    const newData = props.data.filter((item) => item.id !== props.dataItem.id);
    datasetData.value = { ...datasetData.value, values: newData };
  };

  return (
    <td>
      <ColorChangingIcon
        icon={faTrashCan}
        name={"btnUserGroupDelete_" + props.dataIndex}
        initialPrimaryColor="#6e6e6e"
        initialSecondaryColor="#919191"
        padding="0 2px 0 0"
        onClick={handleDeleteRecord}
      />
    </td>
  );
};
